var render = function (_h,_vm) {var _c=_vm._c;return _c('small',_vm._b({staticClass:"mtx-badge text-center",class:[_vm.$options.bgClass(_vm.props.variant), _vm.data.staticClass, _vm.data.class]},'small',_vm.data.attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }